import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ListDTO, ListResponseAPI } from 'src/lib/queries';
import {
    FINANCIAL_DOCUMENT_PAYMENT_STATUS,
    FINANCIAL_DOCUMENT_STATUS,
    FinancialDocument,
} from 'src/features/financialDocuments/utils/types';
import { CURRENCY } from 'src/types';

const RESOURCE = '/financial-documents/financial-document/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    accounting_range?: string;
    status?: FINANCIAL_DOCUMENT_STATUS;
    currency?: CURRENCY;
    payment_status?: FINANCIAL_DOCUMENT_PAYMENT_STATUS[];
    customer?: string;
    subscription?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<FinancialDocument>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_FINANCIAL_DOCUMENTS_RESOURCE, useQueryHook as useListFinancialDocuments };
